import { render, staticRenderFns } from "./_callLogsTable.vue?vue&type=template&id=9f0694a8&scoped=true"
import script from "./_callLogsTable.vue?vue&type=script&lang=js"
export * from "./_callLogsTable.vue?vue&type=script&lang=js"
import style0 from "./_callLogsTable.vue?vue&type=style&index=0&id=9f0694a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f0694a8",
  null
  
)

export default component.exports